import React from 'react';
import {Heading, SimpleGrid, VStack, useColorModeValue } from '@chakra-ui/react';
import MusicCard from './MusicCard';

const MusicSection = ({ music }) => {
  const headingColor = useColorModeValue('brand.accent', 'brand.accent');

  return (
    <VStack spacing={8} align="stretch" px={{ base: 4, md: 8, lg: 12 }}>
      <Heading
        as="h2"
        size={{ base: "xl", md: "2xl" }}
        textAlign="center"
        color={headingColor}
        pb={4}
        borderBottom="2px solid"
        borderColor="brand.700"
        mx="auto" // Center the heading border
        maxW="fit-content" // Make border only as wide as text
        borderRadius="md"
        px={4}
      >
        My Music
      </Heading>
      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 3, lg: 4 }} // Responsive grid columns
        spacing={8} // Space between grid items
        justifyItems="center" // Center cards within their grid cells
      >
        {music && music.map((song) => ( // Ensure music array exists before mapping
          <MusicCard key={song.id} song={song} />
        ))}
      </SimpleGrid>
    </VStack>
  );
};

export default MusicSection;